<div class="container-fluid mt-4" *ngIf="items?.length > 0">
  <h5>{{ notification.libelle }}</h5>

  <div class="table-responsive" style="max-height: 400px; overflow: auto">
    <table class="table table-striped table-bordered">
      <tbody>

        <!-- IMAGE ROW -->
        <ng-container *ngIf="items[0].image_url">
          <tr>
            <th class="text-capitalize">Image</th>
            <td class="p-2 text-center">
              <img
                [src]="items[0].image_url"
                alt="Image"
                class="img-fluid clickable-img"
                (click)="openPreview(items[0].image_url)"
                (error)="onImageError($event)"
                style="max-height: 200px; object-fit: contain; cursor: zoom-in;"
              />
            </td>
          </tr>
        </ng-container>

        <!-- DOWNLOAD ROW -->
        <ng-container *ngIf="items[0].file_url">
          <tr>
            <th class="text-capitalize">Fichier</th>
            <td class="p-2">
              <a
                [href]="items[0].file_url"
                download
                target="_blank"
                rel="noopener noreferrer"
                class="btn btn-primary btn-sm"
              >
                Download File
              </a>
            </td>
          </tr>
        </ng-container>

        <!-- OTHER FIELDS -->
        <ng-container *ngFor="let key of getKeys(items[0])">
          <!-- skip image and file fields -->
          <tr *ngIf="key !== 'image_url' && key !== 'file_url'">
            <th class="text-capitalize">{{ formatLabel(key) }}</th>
            <td>{{ items[0][key] || '—' }}</td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>
</div>

<!-- FULLSCREEN IMAGE OVERLAY -->
<ng-container *ngIf="previewOpen">
  <div class="image-overlay" (click)="closePreview()">
    <img
      [src]="previewSrc"
      alt="Preview"
      class="preview-img"
      (click)="$event.stopPropagation()"
    />
    <span class="close-btn" (click)="closePreview()">&times;</span>
  </div>
</ng-container>
